<template>
    <div class="bg-[#0E0D36] text-[#BDBDBD]">
        <div
            class="container w-full max-w-full space-y-5 px-5 py-4 lg:max-w-[1150px] lg:space-y-10 lg:px-0 lg:pb-20 lg:pt-10 lg:text-lg"
        >
            <div class="relative h-full w-full">
                <img
                    :src="`${staticUrl}/assets/img/banner/euro/banner-13-pdp-${locale}.jpg`"
                    class="loader-image hidden min-h-[220px] rounded-xl lg:block"
                    alt="image"
                />
                <img
                    :src="`${staticUrl}/assets/img/banner/euro/banner-13-pdp-mobile-${locale}.jpg`"
                    class="loader-image flex min-h-[120px] w-full rounded-xl lg:hidden"
                    alt="image"
                />
            </div>

            <!-- section 1 -->
            <div>
                <div
                    class="mb-4 text-left text-xs font-semibold text-white lg:mb-5 lg:text-base"
                >
                    {{ $t('promotions.slot_debate.summary') }}
                </div>
                <div class="grid grid-cols-3 gap-2.5 lg:grid-cols-6">
                    <!-- Offer -->
                    <div
                        class="flex flex-col justify-between rounded-xl bg-[#1F1E5F] p-4"
                    >
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9 12L11 14L15 10M2 9C2.79565 9 3.55871 9.31607 4.12132 9.87868C4.68393 10.4413 5 11.2044 5 12C5 12.7956 4.68393 13.5587 4.12132 14.1213C3.55871 14.6839 2.79565 15 2 15V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H20C20.5304 19 21.0391 18.7893 21.4142 18.4142C21.7893 18.0391 22 17.5304 22 17V15C21.2044 15 20.4413 14.6839 19.8787 14.1213C19.3161 13.5587 19 12.7956 19 12C19 11.2044 19.3161 10.4413 19.8787 9.87868C20.4413 9.31607 21.2044 9 22 9V7C22 6.46957 21.7893 5.96086 21.4142 5.58579C21.0391 5.21071 20.5304 5 20 5H4C3.46957 5 2.96086 5.21071 2.58579 5.58579C2.21071 5.96086 2 6.46957 2 7V9Z"
                                    stroke="white"
                                    stroke-width="1.4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            <div
                                class="pt-1 text-[10px] font-bold uppercase text-[#8785FC] lg:text-base"
                            >
                                {{ $t('promotions.slot_debate.title_1') }}
                            </div>
                        </div>
                        <div
                            class="text-xs font-semibold text-white lg:text-base"
                        >
                            {{ $t('promotions.slot_debate.desc_1') }}
                        </div>
                    </div>
                    <!-- Eligibility -->
                    <div
                        class="flex flex-col justify-between rounded-xl bg-[#1F1E5F] p-4"
                    >
                        <div>
                            <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M16.3334 21V19C16.3334 17.9391 15.9119 16.9217 15.1618 16.1716C14.4117 15.4214 13.3942 15 12.3334 15H6.33337C5.27251 15 4.25509 15.4214 3.50495 16.1716C2.7548 16.9217 2.33337 17.9391 2.33337 19V21M22.3334 21V19C22.3327 18.1137 22.0377 17.2528 21.4947 16.5523C20.9517 15.8519 20.1915 15.3516 19.3334 15.13M16.3334 3.13C17.1938 3.3503 17.9564 3.8507 18.501 4.55231C19.0456 5.25392 19.3412 6.11683 19.3412 7.005C19.3412 7.89317 19.0456 8.75608 18.501 9.45769C17.9564 10.1593 17.1938 10.6597 16.3334 10.88M13.3334 7C13.3334 9.20914 11.5425 11 9.33337 11C7.12423 11 5.33337 9.20914 5.33337 7C5.33337 4.79086 7.12423 3 9.33337 3C11.5425 3 13.3334 4.79086 13.3334 7Z"
                                    stroke="white"
                                    stroke-width="1.4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <div
                                class="pt-1 text-[10px] font-bold uppercase text-[#8785FC] lg:text-base"
                            >
                                {{ $t('promotions.slot_debate.title_2') }}
                            </div>
                        </div>

                        <div
                            class="text-xs font-semibold text-white lg:text-base"
                        >
                            {{ $t('promotions.slot_debate.desc_2') }}
                        </div>
                    </div>
                    <!-- Claim -->
                    <div
                        class="flex flex-col justify-between rounded-xl bg-[#1F1E5F] p-4"
                    >
                        <div>
                            <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.6667 15H13.6667C14.1972 15 14.7059 14.7893 15.081 14.4142C15.456 14.0391 15.6667 13.5304 15.6667 13C15.6667 12.4696 15.456 11.9609 15.081 11.5858C14.7059 11.2107 14.1972 11 13.6667 11H10.6667C10.0667 11 9.56675 11.2 9.26675 11.6L3.66675 17M7.66675 21L9.26675 19.6C9.56675 19.2 10.0667 19 10.6667 19H14.6667C15.7667 19 16.7667 18.6 17.4667 17.8L22.0667 13.4C22.4526 13.0353 22.6779 12.5323 22.6929 12.0016C22.7079 11.4708 22.5114 10.9559 22.1467 10.57C21.7821 10.1841 21.279 9.95889 20.7483 9.94389C20.2176 9.92888 19.7026 10.1253 19.3167 10.49L15.1167 14.39M2.66675 16L8.66675 22M19.5667 9C19.5667 10.6016 18.2684 11.9 16.6667 11.9C15.0651 11.9 13.7667 10.6016 13.7667 9C13.7667 7.39837 15.0651 6.1 16.6667 6.1C18.2684 6.1 19.5667 7.39837 19.5667 9ZM9.66675 5C9.66675 6.65685 8.3236 8 6.66675 8C5.00989 8 3.66675 6.65685 3.66675 5C3.66675 3.34315 5.00989 2 6.66675 2C8.3236 2 9.66675 3.34315 9.66675 5Z"
                                    stroke="white"
                                    stroke-width="1.4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <div
                                class="pt-1 text-[10px] font-bold uppercase text-[#8785FC] lg:text-base"
                            >
                                {{ $t('promotions.slot_debate.title_3') }}
                            </div>
                        </div>

                        <div
                            class="text-xs font-semibold text-white lg:text-base"
                        >
                            {{ $t('promotions.slot_debate.desc_3') }}
                        </div>
                    </div>
                    <!-- Calculation -->
                    <div
                        class="col-span-3 flex flex-col gap-3 rounded-xl bg-[#1F1E5F] p-4"
                    >
                        <div class="flex justify-between">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 9V13L14 15M5 3L2 6M22 6L19 3M6.38 18.7L4 21M17.64 18.67L20 21M20 13C20 17.4183 16.4183 21 12 21C7.58172 21 4 17.4183 4 13C4 8.58172 7.58172 5 12 5C16.4183 5 20 8.58172 20 13Z"
                                    stroke="white"
                                    stroke-width="1.4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <div
                                class="text-[10px] font-bold uppercase text-[#8785FC] lg:text-base"
                            >
                                {{ $t('promotions.slot_debate.title_4') }}
                            </div>
                        </div>

                        <div
                            class="text-xs font-semibold text-white lg:text-base"
                        >
                            <ul class="ml-4 list-disc">
                                <li
                                    v-for="(item, index) in list_1"
                                    :key="index"
                                >
                                    {{ $t(item.title) }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div></div>
                </div>
            </div>

            <!-- section 2 -->
            <div class="rounded-xl bg-[#1F1E5F] p-4 lg:p-5">
                <div class="mb-5 flex justify-between">
                    <div class="font-semibold text-white">Games</div>
                    <div
                        class="flex cursor-pointer items-center rounded-full bg-[#636394] p-2 text-xs text-white"
                        @click="navigateTo('/games/slots?partner=')"
                    >
                        {{ $t('home.view_more') }}
                    </div>
                </div>
                <div>
                    <ThaBlocksPromotionSlotsGames></ThaBlocksPromotionSlotsGames>
                </div>
            </div>
            <!-- section 3 -->
            <div class="rounded-xl bg-[#1F1E5F] p-4 lg:p-5">
                <div class="mb-5 flex justify-between">
                    <div class="font-semibold text-white">
                        {{ $t('promotions.slot_debate.provider') }}
                    </div>
                </div>
                <div class="flex w-full">
                    <ThaBlocksPromotionSlotsProviders></ThaBlocksPromotionSlotsProviders>
                </div>
            </div>

            <!-- section 4 -->
            <div>
                <div class="mb-5 flex justify-between">
                    <div class="font-semibold text-white">
                        {{ $t('promotions.slot_debate.tables_title') }}
                    </div>
                </div>

                <!-- grid 2 -->
                <div class="grid divide-y lg:grid-cols-2 lg:divide-y-0">
                    <!-- left -->
                    <div class="pb-2.5 lg:pb-0 lg:pr-5">
                        <!-- table 1 -->
                        <div
                            class="mb-5 overflow-hidden rounded-b-xl rounded-t-xl text-[16px]"
                        >
                            <table
                                class="mx-auto w-full table-fixed text-center text-[16px] text-white"
                            >
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="py-3">
                                                {{
                                                    $t(
                                                        'promotions.slot_debate.table_1.header_1'
                                                    )
                                                }}
                                            </div>
                                        </th>
                                        <th>
                                            <div class="py-3">
                                                {{
                                                    $t(
                                                        'promotions.slot_debate.table_1.header_2'
                                                    )
                                                }}
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="py-3">0 - 4,199</div>
                                        </td>
                                        <td>
                                            <div class="py-3">0.3</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="py-3">
                                                4,200 - 11,199
                                            </div>
                                        </td>
                                        <td><div class="py-3">0.4</div></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="py-3">
                                                11,200 - 21,199
                                            </div>
                                        </td>
                                        <td>
                                            <div class="py-3">0.5</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="py-3">
                                                21,200 - 41,999
                                            </div>
                                        </td>
                                        <td>
                                            <div class="py-3">0.6</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="py-3">
                                                42,000 - 104,999
                                            </div>
                                        </td>
                                        <td>
                                            <div class="py-3">0.7</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="py-3">
                                                105,000 - 209,999
                                            </div>
                                        </td>
                                        <td>
                                            <div class="py-3">0.8</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="py-3">
                                                210,000
                                                {{
                                                    $t(
                                                        'promotions.slot_debate.and_above'
                                                    )
                                                }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="py-3">0.9</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="flex text-left">
                            {{ $t('promotions.slot_debate.example_1') }}
                        </div>
                    </div>
                    <!-- right -->
                    <div class="pt-2.5 lg:pl-5 lg:pt-0">
                        <!-- table 2 -->
                        <div
                            class="mb-5 overflow-hidden rounded-b-xl rounded-t-xl text-[16px]"
                        >
                            <table
                                class="mx-auto w-full table-fixed text-center text-[16px] text-white"
                            >
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="py-3">
                                                {{
                                                    $t(
                                                        'promotions.slot_debate.table_2.header_1'
                                                    )
                                                }}
                                            </div>
                                        </th>
                                        <th>
                                            <div class="py-3">
                                                {{
                                                    $t(
                                                        'promotions.slot_debate.table_2.header_2'
                                                    )
                                                }}
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="py-3">1,000,000</div>
                                        </td>
                                        <td>
                                            <div class="py-3">5%</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="py-3">2,000,000</div>
                                        </td>
                                        <td>
                                            <div>
                                                <div class="py-3">10%</div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="mb-4">
                            {{ $t('promotions.slot_debate.additional') }}
                        </div>
                        <div class="mb-4">
                            {{ $t('promotions.slot_debate.additional_note') }}
                        </div>
                        <div class="mb-4">
                            {{ $t('promotions.slot_debate.example_2') }}
                        </div>
                        <div class="mb-4">
                            {{ $t('promotions.slot_debate.example_2_1') }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- section 5 -->
            <div>
                <div
                    class="mb-2.5 flex text-left text-xl font-semibold text-white"
                >
                    {{ $t('promotions.slot_debate.terms_and_conditions') }}
                </div>
                <ul class="mb-4 ml-8 list-disc space-y-2">
                    <li v-for="(item, index) in list_2" :key="index">
                        {{ $t(item.title) }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
const staticUrl = useRuntimeConfig().public.staticUrl

const { locale } = useI18n()

const list_1 = ref([
    {
        key: 1,
        title: 'promotions.slot_debate.list_1.item_1',
    },
    {
        key: 2,
        title: 'promotions.slot_debate.list_1.item_2',
    },
])
const list_2 = ref([
    {
        key: 1,
        title: 'promotions.slot_debate.list_2.item_1',
    },
    {
        key: 2,
        title: 'promotions.slot_debate.list_2.item_2',
    },
    {
        key: 3,
        title: 'promotions.slot_debate.list_2.item_3',
    },
    {
        key: 4,
        title: 'promotions.slot_debate.list_2.item_4',
    },
    {
        key: 5,
        title: 'promotions.slot_debate.list_2.item_5',
    },
    {
        key: 6,
        title: 'promotions.slot_debate.list_2.item_6',
    },
])
</script>
<style lang="css" scoped>
th {
    background-color: #1f1e5f;
    padding: 1px;
    margin: 1px;
    background-clip: content-box;
}
td {
    background-color: #323266;
    padding: 1px;
    margin: 1px;
    background-clip: content-box;
}
</style>
